import { Instance, onSnapshot, types, unprotect } from "mobx-state-tree";
import { createContext, useContext } from "react";
import { AuthModel } from "./stores/auth/models";
import { TopicsModel } from "./stores/topics/models";
import { SkillsModel } from "./stores/skills/models";
import { QuestionsModel } from "./stores/questions/models";
import { TexHelpersModel } from "./stores/texHelpers/models";

const RootModel = types.model({
	authStore: AuthModel,
	topicsStore: TopicsModel,
	skillsStore: SkillsModel,
	questionsStore: QuestionsModel,
	texHelpersStore: TexHelpersModel,
});

export type RootInstance = Instance<typeof RootModel>;
const RootStoreContext = createContext<null | RootInstance>(null);

const initialPage = {
	from: undefined,
	current_page: undefined,
	last_page: undefined,
	per_page: undefined,
	to: undefined,
	total: undefined,
};

export const rootStore = RootModel.create({
	authStore: {
		authenticatedUser: null,
		isLoading: false,
		isLogged: false,
		permissions: null,
	},
	topicsStore: {
		topics: [],
		page: initialPage,
	},
	skillsStore: {
		skills: [],
		page: initialPage,
	},
	questionsStore: {
		questions: [],
		page: initialPage,
	},
	texHelpersStore: {
		texHelpers: [],
	},
});

unprotect(rootStore);

export const Provider = RootStoreContext.Provider;

export function useMst() {
	const store = useContext(RootStoreContext);
	if (store === null) {
		throw new Error("Store cannot be null, please add a context provider");
	}
	return store;
}
